/**
 * A shared empty-array instance that maintains referential integrity and avoids re-allocations.
 * Frozen at runtime to prevent accidental mutation (which would corrupt all consumers).
 */
export const EMPTY_ARRAY: never[] = Object.freeze([]) as never[];
